<template>
  <div
    v-if="!isEmpty"
    ref="scrollContainer"
    data-scroll-container
    class="h-full p-2 overflow-y-auto"
    :style="{
      'max-height': !isMobile
        ? fixedHeight && !isClipped
          ? `${fixedHeight}px`
          : 'calc(100vh - 76px)'
        : 'none',
    }"
    @scroll="recalculateScroll()"
  >
    <div class="w-full h-full md:h-auto" ref="resultContainer">
      <component
        :is="resolveResultItem(result.resultType)"
        v-for="(result, index) in results"
        :key="result.id"
        :data="result"
        :query="query"
        :isSelected="index === selectedIndex"
        @clicked="$emit('clickedResult', $event)"
        :isLast="index === results.length - 1"
      >
      </component>
      <GradientFade :show="showFade" class="md:rounded" />
    </div>
  </div>

  <EmptyState v-else />
</template>

<script>
import UserResultItem from "./UserResultItem";
import ClubResultItem from "./ClubResultItem";
import EmptyState from "./EmptyState";
import { GradientFade } from '@sportsrecruits/playbook';
import media from "@/mixins/media";

const resultThreshold = 5;

export default {
  mixins: [media],

  components: {
    UserResultItem,
    ClubResultItem,
    EmptyState,
    GradientFade,
  },

  props: {
    results: { type: Array, required: true },
    query: { type: String, required: true },
    selectedIndex: { type: Number, default: null },
  },

  data() {
    return {
      fixedHeight: null,
      isScrolledToBottom: false,
      isClipped: false,
    };
  },

  computed: {
    isEmpty() {
      return this.results.length === 0;
    },

    showFade() {
      return this.results.length > resultThreshold && !this.isScrolledToBottom;
    },
  },

  methods: {
    containerIsClipping() {
      this.$nextTick((vm) => {
        this.isClipped =
          this.$refs.scrollContainer.getBoundingClientRect().bottom >
          Math.max(
            document.documentElement.clientHeight,
            window.innerHeight || 0
          );
      });
    },
    recalculateHeight() {
      const height = this.$refs.results
        ? this.$refs.results
        .slice(0, resultThreshold)
        .map((component) => component.$el)
        .map((element) => element.outerHeight)
        .reduce((total, height) => total + height, 0)
      : 0;

      this.fixedHeight =
        height +
        window
          .getComputedStyle(this.$refs.scrollContainer)
          .getPropertyValue("padding-top") +
        window
          .getComputedStyle(this.$refs.scrollContainer)
          .getPropertyValue("padding-bottom");
    },

    recalculateScroll() {
      const $container = this.$refs.scrollContainer;
      if ($container) {
        this.isScrolledToBottom =
          $container.scrollTop + $container.clientHeight >=
          $container.scrollHeight;
      } else {
        this.isScrolledToBottom = false;
      }
    },

    resolveResultItem(type) {
      let resultItemMap = {
        'site_user' : 'UserResultItem',
        'club'      : 'ClubResultItem',
      };

      return resultItemMap[type];

    },
  },

  watch: {
    results: {
      deep: true,
      immediate: true,
      handler() {
        this.$nextTick(() => {
          this.recalculateHeight();
          this.recalculateScroll();
          this.containerIsClipping();
        });
      },
    },
  },

  mounted() {
    this.recalculateHeight();
    this.recalculateScroll();
  },
};
</script>
